<script setup lang="ts">

import ButtonInput from "@/components/inputs/Button.vue";
import Translator from '@/utils/common/Translator'
import {defineProps, ref} from "vue";
import {useErrorsStore} from "@/stores/ToastDataStore.ts";
import type {QInput} from "quasar";
import NamaIcon from "@/components/icons/NamaIcon.vue";
const props = defineProps<{ urlToken?: string}>();

const token = ref(props.urlToken ?? "");
const password = ref("");
const canShowPassword = ref(false);
const reTypePassword = ref("");
const reTypePasswordValidationError = ref<string>("");
const tokenRef = ref<QInput>();
const passwordRef = ref<QInput>();
const reTypePasswordRef = ref<QInput>();
const emit = defineEmits(['confirmChangePassword']);


function onContinueClick() {
  if (!validateConfirmPassword())
    return;
  emit('confirmChangePassword', password.value, reTypePassword.value, token.value);
}

function validateConfirmPassword() {
  if (password.value && reTypePassword.value && password.value === reTypePassword.value)
    return true;
  useErrorsStore().pushErrorStr(Translator.translateId("passwordsDoNotMatch"));
  return false;
}

function onEnterDown() {
  if (!token.value) {
    tokenRef.value?.focus();
  } else if (!password.value) {
    passwordRef.value?.focus();
  } else if (!reTypePassword.value) {
    reTypePasswordRef.value?.focus();
  } else {
    onContinueClick();
  }
}
</script>

<template>
  <div class="tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center tw-flex-col">
    <div class="tw-w-1/2 tw-h-full tw-flex tw-justify-center tw-items-center tw-flex-col">
      <h2
        class="tw-text-center tw-text-primary-light dark:tw-text-primary-dark dark:tw-text-gray-200 tw-text-4xl tw-font-bold mobile:tw-text-3xl tw-pb-6"
        v-text="Translator.translateId('resetPassword')"/>
      <div class="tw-w-full tw-flex tw-gap-2 tw-flex-col">
        <q-input
          input-class="nama-input-class"
          outlined
          class="nama-customize-dense-input nama-focused-input nama-field-input"
          v-model="token"
          :placeholder="Translator.translateId('resetToken')"
          @keyup.enter="onEnterDown"
          ref="tokenRef">
          <template v-slot:prepend>
            <NamaIcon default-icon="nm-user"/>
          </template>
        </q-input>
        <q-input
          input-class="nama-input-class"
          outlined
          class="nama-customize-dense-input nama-focused-input nama-field-input"
          v-model="password"
          :type="canShowPassword?'text':'password'"
          :placeholder="Translator.translateId('newPassword')"
          @keyup.enter="onEnterDown"
          ref="passwordRef">
          <template v-slot:prepend>
            <NamaIcon default-icon="nm-lock"/>
          </template>
          <template v-slot:append>
            <NamaIcon class="tw-cursor-pointer" @click="canShowPassword = !canShowPassword"
                      :default-icon="canShowPassword?'visibility':'visibility_off'"/>
          </template>
        </q-input>
        <q-input
          input-class="nama-input-class"
          outlined
          class="nama-customize-dense-input nama-focused-input nama-field-input"
          v-model="reTypePassword"
          :type="canShowPassword?'text':'password'"
          :placeholder="Translator.translateId('confirmNewPassword')"
          :error-message="reTypePasswordValidationError"
          autocomplete="off"
          @keyup.enter="onEnterDown"
          ref="reTypePasswordRef">
          <template v-slot:prepend>
            <NamaIcon default-icon="nm-lock"/>
          </template>
        </q-input>
        <ButtonInput :text="Translator.translateId('Confirm')" @click="onContinueClick" @keydown.enter="onContinueClick"/>
      </div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<style scoped>

</style>
